export default {
	import (params = new URLSearchParams()) {
		return Axios.post(API_BASE + '/signage_file_import/import', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'signage_file_import/delete', params)
	},
	get (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'signage_file_import/get', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/SignageFile.js